import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { of, switchMap } from 'rxjs';

export const FunctionGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);

  // Check the userright by function
  return inject(UserService).user$.pipe(
    switchMap((user) => {
      const functionName = route?.data?.fn ?? null;
      if (functionName === null) {
        // Allow the access
        return of(true);
      }
      if ((user.permission ?? []).includes(functionName)) {
        // Allow the access
        return of(true);
      }
      router.navigate(['']);
      return of(false);
    })
  );
};
